module.exports = __webpack_public_path__ + "static/img/celoscope-6.be2550b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-6.jpg
// module id = AC2K
// module chunks = 51